import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connectToStores} from 'fluxible-addons-react';
import {signUp} from '../../../actions/AuthenticationActionCreators';
import {defineMessages, FormattedMessage, intlShape} from 'react-intl';
import Actions from '../../../constants/Actions';
import EditBankInfo from '../../Bank/components/EditBankInfo';
import {FormStateShape} from '../../../utils/react/Shapes';
import FormState from '../../../constants/FormState';
import classnames from 'classnames';

const messages = defineMessages({
  signUp: {
    id: 'signUp.welcome',
    defaultMessage: 'Thank you for choosing Ignite Sales.',
    description: 'A welcome message for the user when they visit the home page.'
  },
  signUpTitle: {
    id: 'signUp.title',
    defaultMessage: 'Sign Up',
    description: 'A welcome message for the user when they visit the home page.'
  },
  signUpPrompt: {
    id: 'signUp.prompt',
    defaultMessage: 'Please fill out the form below to create your account.',
    description: 'A welcome message for the user when they visit the home page.'
  },
  signUpComplete: {
    id: 'signUp.complete',
    defaultMessage: 'Thank you for signing up.  An email will be sent to you shortly with instructions to activate your account.',
    description: 'A welcome message for the user when they visit the home page.'
  }
});

//TODO: Make a generic form component.
@connectToStores(['SignUpStore'], (context) => {
  const SignUpStore = context.getStore('SignUpStore');

  return {
    formState: SignUpStore.getFormState()
  };
})
class SignUp extends Component {

  static propTypes = {
    formState: FormStateShape
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      emailAddress: '',
      password: '',
      rememberMe: true
    };
  }

  static async loadAction(context) {
    context.dispatch(Actions.RESET_SIGN_UP, {});
  }

  processSignUp = ({
    name,
    url,
    firstName,
    lastName,
    email,
    phone,
    street,
    city,
    state,
    zip
  }) => {
    this.context.executeAction(signUp, {
      name,
      url,
      contact: {
        firstName,
        lastName,
        email: email.toLowerCase(),
        phone
      },
      address: {
        street,
        city,
        state,
        zip
      }
    });
  };

  render() {
    const {formState} = this.props;

    const promptMessage = formState === FormState.COMPLETED ? messages.signUpComplete : messages.signUpPrompt;

    const loginContainerClasses = classnames({
      'login-container': true,
      'loading': formState === FormState.PROCESSING
    });

    const errorMessage = formState === FormState.ERROR ? <div key='error' className='alert alert-danger'>
        There was an error creating your account. Please ensure you have entered valid information for the fields below.
        If you need further assistance, please contact <a href='mailto:support@ignitesales.com'>Ignite Sales Support</a> and we will get back to you shortly.
      </div> : <div key='error' />;

    const signUpForm = formState === FormState.COMPLETED ? null : [
      <hr key='hr' />,
      errorMessage,
      <div key='block' className='card-body'>
        <EditBankInfo
          saveHandler={this.processSignUp}
          saveMessage={messages.signUpTitle}
          allowCancel={false}
          allowEditName
          initBankInfo={{
            id: '-1',
            name: '',
            key: '',
            url: '',
            contact: {
              firstName: '',
              lastName: '',
              email: '',
              phone: ''
            },
            address: {
              street: '',
              city: '',
              state: '',
              zip: ''
            }
          }}
        />
      </div>
    ];

    return <div className='home sign-up flex-element flex-container flex-vertical scroll-y'>
      <section className='user-info flex-center flex-element flex-container flex-vertical'>
        <h1>
          <FormattedMessage { ...messages.signUp } />
        </h1>
        <div className={loginContainerClasses}>
          <div className='card'>
            <div className='card-body pb-0'>
              <h2 className='card-title'>
                <FormattedMessage { ...messages.signUpTitle } />
              </h2>
              <h4 className='card-subtitle text-muted'>
                <FormattedMessage { ...promptMessage } />
              </h4>
            </div>
            {signUpForm}
          </div>
        </div>
      </section>
    </div>;
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/apps/Account/components/SignUp.js